import api from './api';
import { Durchfuehrungszeitraum, DurchfuehrungszeitraumCreate } from '../types';

export const durchfuehrungszeitraeumeService = {
  list: async (params?: { audit_id?: number }): Promise<Durchfuehrungszeitraum[]> => {
    const response = await api.get('/durchfuehrungszeitraeume/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Durchfuehrungszeitraum> => {
    const response = await api.get(`/durchfuehrungszeitraeume/${id}`);
    return response.data;
  },

  create: async (data: DurchfuehrungszeitraumCreate): Promise<Durchfuehrungszeitraum> => {
    const response = await api.post('/durchfuehrungszeitraeume/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<DurchfuehrungszeitraumCreate>): Promise<Durchfuehrungszeitraum> => {
    const response = await api.put(`/durchfuehrungszeitraeume/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/durchfuehrungszeitraeume/${id}`);
  },
};
